var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 3.3125C1.875 3.06386 1.97377 2.8254 2.14959 2.64959C2.3254 2.47377 2.56386 2.375 2.8125 2.375H12.1875C12.4361 2.375 12.6746 2.47377 12.8504 2.64959C13.0262 2.8254 13.125 3.06386 13.125 3.3125V4.61625C13.1249 4.94774 12.9932 5.26563 12.7587 5.5L9.375 8.88375V13.5237C9.37502 13.641 9.34507 13.7562 9.28801 13.8586C9.23095 13.961 9.14866 14.047 9.04896 14.1087C8.94927 14.1703 8.83548 14.2054 8.71839 14.2107C8.60131 14.2159 8.48482 14.1912 8.38 14.1387L6.05688 12.9775C5.92711 12.9126 5.81797 12.8129 5.74169 12.6895C5.66541 12.5661 5.62501 12.4238 5.625 12.2787V8.88375L2.24125 5.5C2.00681 5.26563 1.87507 4.94774 1.875 4.61625V3.3125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.9d4d19faf07d1d4413bfe16355a7e66f.svg";
export { ForwardRef as ReactComponent };